import { css } from "../../../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      width: "162px",
      height: "162px",
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      backgroundColor: "white",
      display: "flex",
      flexDirection: "column",
      color: "headlineGrey",
      border: "1px solid",
      borderColor: "disabledGrey",
      borderRadius: "4px",
      textAlign: "center",
      justifyContent: "flex-start",
      paddingTop: "baseUnit.mobile4",
      desktop: {
        width: "160px",
        minHeight: "160px",
      },
    }),
  icon: () =>
    css({
      margin: "0 auto",
      "& svg": {
        width: "baseUnit.mobile4",
        height: "baseUnit.mobile4",
      },
    }),
  label: () =>
    css({
      padding: "baseUnit.mobile1",
    }),
};
